module.exports = __webpack_public_path__ + "img/bxa-logo.1b1b4c4c.png";